class LowInventoryAlert {
    constructor({enabled = false, alertType = 'INVENTORY_ONLY', threshold = 0} = {}) {
        // Validate enabled is boolean
        if (typeof enabled !== 'boolean') {
            throw new Error('enabled must be a boolean');
        }

        // Validate alertType
        const validTypes = ['INVENTORY_ONLY', 'RESERVED_ONLY', 'COMBINED'];
        if (!validTypes.includes(alertType)) {
            throw new Error(`alertType must be one of: ${validTypes.join(', ')}`);
        }

        // Validate threshold (non-negative integer)
        const parsedThreshold = parseInt(threshold);
        if (isNaN(parsedThreshold) || parsedThreshold < 0) {
            throw new Error('threshold must be a non-negative integer');
        }

        this.enabled = enabled;
        this.alertType = alertType;
        this.threshold = parsedThreshold;
    }

    getForDb() {
        return {
            enabled: this.enabled,
            alertType: this.alertType,
            threshold: this.threshold
        };
    }
}

class ProductDetailAlerts {
    constructor({lowInventory} = {}) {
        // if null in DB, create default object to replace it
        if (lowInventory === null || lowInventory === undefined) {
            this.lowInventory = new LowInventoryAlert();
        } else {
            this.lowInventory = new LowInventoryAlert(lowInventory);
        }
    }

    getForDb() {
        return {
            lowInventory: this.lowInventory.getForDb()
        };
    }
}

export { ProductDetailAlerts, LowInventoryAlert };
